import React from 'react';
import { FadeIn } from './FadeIn';
import { UserMinusIcon, TrendingUpIcon, UsersIcon, DollarSignIcon } from 'lucide-react';
export function PainStories() {
  const pains = [{
    icon: <UserMinusIcon className="w-8 h-8 text-red-400" data-id="element-98" />,
    title: 'El alumno que no vuelve',
    text: 'Un alumno lleva 2 meses entrenando con vos. Mejoró. Vos lo sabés. Pero un día dice que lo piensa y nunca más aparece. No tenés cómo demostrarle que mejoró. No hay datos, no hay fichas, no hay evidencia. Solo tu palabra compitiendo contra el precio del otro coach que cobra menos.'
  }, {
    icon: <TrendingUpIcon className="w-8 h-8 text-orange-400" data-id="element-99" />,
    title: 'La pregunta que te incomoda',
    text: 'Alguien te pregunta cómo está progresando. Vos le decís que bien, que se nota. Pero en el fondo los dos saben que eso no es una respuesta. Es una opinión. Y las opiniones no retienen alumnos. Los datos sí. Las fichas sí. Los resultados medibles sí.'
  }, {
    icon: <UsersIcon className="w-8 h-8 text-yellow-400" data-id="element-100" />,
    title: 'La clase sin estructura real',
    text: 'Llegás al grupo con una idea general de lo que querés trabajar. Improvisás sobre la marcha. La sesión "sale bien" pero sin progresión real. Sin anclaje técnico. Sin saber si hoy acercaste al alumno a su objetivo o simplemente lo cansaste.'
  }, {
    icon: <DollarSignIcon className="w-8 h-8 text-hyrox-orange" data-id="element-101" />,
    title: 'El precio que nunca subís',
    text: 'Llevas tiempo cobrando lo mismo porque cada vez que pensás en subir el precio aparece la misma pregunta: ¿cómo lo justifico? ¿Y si se van? La verdad incómoda es que sin un sistema visible, sin resultados medibles y sin diferenciación clara, no tenés argumento. Todavía.'
  }];
  return <section className="py-16 sm:py-24 px-4 bg-hyrox-dark" data-id="element-102">
      <div className="max-w-5xl mx-auto" data-id="element-103">
        <FadeIn data-id="element-104">
          <h2 className="text-3xl sm:text-4xl font-display font-bold text-center text-white mb-12" data-id="element-105">
            Y mientras tanto,{' '}
            <span className="text-red-400" data-id="element-106">pasan cosas que duelen.</span>
          </h2>
        </FadeIn>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 sm:gap-8" data-id="element-107">
          {pains.map((pain, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-108">
              <div className="bg-hyrox-surface border border-hyrox-muted p-6 sm:p-8 rounded-2xl h-full hover:border-hyrox-orange/30 transition-colors" data-id="element-109">
                <div className="bg-hyrox-dark w-16 h-16 rounded-xl flex items-center justify-center mb-6 border border-hyrox-muted" data-id="element-110">
                  {pain.icon}
                </div>
                <h3 className="text-xl font-display font-bold text-white mb-4" data-id="element-111">
                  {pain.title}
                </h3>
                <p className="text-gray-400 leading-relaxed" data-id="element-112">{pain.text}</p>
              </div>
            </FadeIn>)}
        </div>
      </div>
    </section>;
}